export default function AchievementSection() {
  return (
    <div className="relative overflow-hidden bg-gradient-to-b from-white via-slate-50 to-white text-slate-900 pt-16 pb-8 md:pt-20 md:pb-10">
      {/* Background blobs */}
      <div className="pointer-events-none absolute inset-0">
        <div className="absolute -top-24 left-1/2 h-[520px] w-[520px] -translate-x-1/2 rounded-full bg-gradient-to-br from-indigo-200/40 via-sky-200/30 to-cyan-200/35 blur-3xl" />
        <div className="absolute -bottom-40 left-[-120px] h-[420px] w-[420px] rounded-full bg-gradient-to-br from-emerald-200/35 via-lime-200/20 to-cyan-200/25 blur-3xl" />
      </div>

      <div className="relative mx-auto max-w-[1280px] px-6 md:px-8">
        {/* Header */}
        <div className="mb-10 text-center">
          {/* <h2 className="text-5xl font-extrabold uppercase tracking-wide text-blue-600">
            Achievement
          </h2> */}
          <p className="mt-3 text-3xl font-extrabold tracking-tight text-slate-900 sm:text-4xl">
            Powered by Multiple
          </p>
          <p className="mt-3 text-3xl font-extrabold tracking-wide text-blue-600 sm:text-4xl">
            Specialized Agents
          </p>
          <p className="mx-auto mt-5 max-w-2xl text-pretty text-lg leading-8 text-slate-600">
            Specialized agents work together like a full quant team.
          </p>
        </div>

        {/* Three image cards */}
        <div className="mx-auto max-w-5xl mt-8 flex items-stretch justify-center gap-6">
          <div className="flex-1 rounded-2xl border-2 border-blue-200 overflow-hidden bg-white shadow-[0_4px_20px_0_rgba(99,102,241,0.08)]">
            <img
              alt="Multi-Agent Reasoning"
              src="/assets/home/multiagents2.png"
              className="w-full h-auto block"
            />
            {/* Agent labels */}
            <div className="mx-auto max-w-5xl flex items-center justify-between gap-4">
              {["Risk Manager", "Market Analyst", "Quantitative Researcher", "Portfolio Manager"].map((label) => (
                <div
                  key={label}
                  className="flex-1 text-center mb-3 px-2 shadow-sm"
                >
                  <span className="text-sm font-semibold text-slate-700">{label}</span>
                </div>
              ))}
            </div>
          </div>
        </div>

      </div>
    </div>
  );
}
